import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { generateKeyBetween } from 'fractional-indexing';
import InstructionStepItem from './InstructionStepItem';

const InstructionTimeline = ({
  steps,
  onEditStep,
  onDeleteStep,
  onHideStep,
  onManageFiles,
  onReorder,
  selectedMunicipality,
  selectedCounty
}) => {
  const handleDragEnd = result => {
    if (!result.destination) return;

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;

    if (sourceIndex === destinationIndex) return;

    // Reorder steps array
    const reorderedSteps = Array.from(steps);
    const [movedStep] = reorderedSteps.splice(sourceIndex, 1);
    reorderedSteps.splice(destinationIndex, 0, movedStep);

    // Calculate new fractional index
    const prevStep = reorderedSteps[destinationIndex - 1];
    const nextStep = reorderedSteps[destinationIndex + 1];

    const prevOrder = prevStep?.order || null;
    const nextOrder = nextStep?.order || null;

    const newOrder = generateKeyBetween(prevOrder, nextOrder);

    // Update the moved step's order
    reorderedSteps[destinationIndex] = {
      ...reorderedSteps[destinationIndex],
      order: newOrder
    };

    // Call parent to update backend
    onReorder(reorderedSteps);
  };

  if (steps.length === 0) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center h-100">
        <p className="xmidFont text-muted mb-0">No steps found</p>
      </div>
    );
  }

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div className="mt-4 bg-white rounded border overflow-auto">
        <table
          className="table table-hover mb-0 w-100"
          style={{ borderCollapse: 'separate', borderSpacing: 0, tableLayout: 'auto' }}
        >
          <colgroup>
            <col style={{ width: '60px' }} />
            <col style={{ width: '140px' }} />
            <col />
            <col style={{ width: '100%' }} />
            <col style={{ width: '140px' }} />
          </colgroup>
          <thead>
            <InstructionStepItem step={{}} stepNumber={0} provided={{}} snapshot={{}} isHeader />
          </thead>
          <Droppable droppableId="instruction-steps">
            {(provided, snapshot) => (
              <tbody
                {...provided.droppableProps}
                ref={provided.innerRef}
                className={snapshot.isDraggingOver ? 'bg-blue-light' : ''}
                style={{ transition: 'background 0.2s' }}
              >
                {steps.map((step, index) => (
                  <Draggable key={step._id} draggableId={step._id} index={index} isDragDisabled={step.isHidden}>
                    {(provided, snapshot) => (
                      <InstructionStepItem
                        step={step}
                        stepNumber={index + 1}
                        provided={provided}
                        snapshot={snapshot}
                        onEdit={onEditStep}
                        onDelete={onDeleteStep}
                        onHide={onHideStep}
                        onManageFiles={onManageFiles}
                        selectedMunicipality={selectedMunicipality}
                        selectedCounty={selectedCounty}
                      />
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </tbody>
            )}
          </Droppable>
        </table>
      </div>
    </DragDropContext>
  );
};

export default InstructionTimeline;
